import * as React from 'react';
import { plural } from '@cian/utils';
import { MetroMoscow16, Walk16, Car16 } from '@cian/ui-kit/icons';
import { TColors } from '@cian/ui-kit/colors';

import {
  IUndergroundInfoForDesktopSchema,
  ETransportType,
} from '../../repositories/favorites/entities/favorite_entity_for_desktop/UndergroundInfoForDesktopSchema';

export interface IUndergroundsProps {
  undergrounds: IUndergroundInfoForDesktopSchema[];
}

const mapTransportType = {
  walk: <Walk16 />,
  transport: <Car16 />,
};

export function getTimeTransportTextForUnderground(time: number, transportType: ETransportType): React.ReactElement {
  return (
    <span className="c-undergrounds__time">
      <span className="c-undergrounds__icon">{mapTransportType[transportType]}</span>
      {` ${time} ${plural(time, ['минута', 'минуты', 'минут'])}`}
    </span>
  );
}

export function Undergrounds({ undergrounds }: IUndergroundsProps) {
  const underground = undergrounds.find(underground => underground.isDefault) || undergrounds[0];

  if (!underground) {
    return null;
  }

  const { lineColor, name, time, transportType } = underground;

  return (
    <div className="c-undergrounds">
      <span className="c-undergrounds__line">
        <span className="c-undergrounds__icon">
          <MetroMoscow16 color={`#${lineColor}` as TColors} />
        </span>
        <span className="c-undergrounds__line-name">{name}</span>
      </span>
      {time && getTimeTransportTextForUnderground(time, transportType as ETransportType)}
    </div>
  );
}
